// Image imports
import edenYerushalmiPng from '../../../images/eden.jpg';

export const edenYerushalmiMemorial = {
  id: 13,
  name: 'Eden Yerushalmi',
  category: 'young-lives',
  images: {
    placeholder: edenYerushalmiPng
  },
  info: `

"She danced through life with grace and joy." - Friend of Eden

# Eden Yerushalmi

![Eden Yerushalmi](${edenYerushalmiPng})
*Eden Yerushalmi, whose smile brought light to everyone around her*

## A Free Spirit Silenced

Eden Yerushalmi was 24 years old when she attended the Nova music festival on October 7, 2023. Friends describe her as vibrant and full of life – a young woman who loved music, dance, and bringing people together. Her kindness was legendary among those who knew her, always the first to offer help or a listening ear.

With her flowing dark hair and radiant smile, Eden lit up every room she entered. She was studying psychology, hoping to help others navigate life's challenges. "She wanted to heal the world," her mother said, "one heart at a time."

## Dreams Interrupted

Eden had so many plans for her future. She dreamed of traveling, of completing her studies, of perhaps one day starting a family of her own. She loved nature and often spoke of wanting to protect the environment for future generations.

The morning of October 7th began as a celebration of music and friendship at the Nova festival. No one could have imagined the horror that would unfold. Eden was among those taken hostage, her family plunged into a nightmare of uncertainty and fear.

## 330 Days of Heartache

For nearly a year, Eden's family campaigned desperately for her release. They held vigils, gave interviews, and kept her photo visible in the public eye. Her sister became her voice, speaking at rallies and to international media, determined that Eden would not be forgotten.

Hope would rise with each rumor of a potential hostage release, only to be dashed when Eden's name was not among those coming home. Still, her family never gave up.

## A Devastating Truth

On September 1, 2024, the IDF announced that they had recovered the bodies of six hostages, including Eden. According to the military, they had been murdered by Hamas shortly before Israeli forces could reach them.

Her funeral brought together hundreds of mourners dressed in white – Eden's favorite color, symbolizing the purity and light she brought to the world. Her favorite songs played as friends and family shared memories of a life that touched so many others.

## Eternal Dance

Eden's mother spoke of her daughter's love of dance: "Even when there was no music playing, Eden was dancing. Her body might now be still, but her spirit will dance forever in our hearts."

Friends planted a garden in her memory – filled with flowers that bloom in different seasons, ensuring that something would always be in bloom, just as Eden's spirit always blossomed regardless of circumstances.

Though her time on earth was cut tragically short, Eden Yerushalmi's legacy lives on in the kindness she showed others and the light she brought into the world.

May her memory be a blessing, and may her spirit continue to dance.

`
};